import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            global_reload_path: '',
        };
    },
    destroyed() {
        this.$toasted.clear();
    },
    computed: {
        ...mapGetters([
            'getConfig',
            'getMenuToggle',
            'getLoginAccountRole',
            'getLoginAccount',
            'haveServiceAccount',
            'haveServiceAccountContract',
            'selectedServiceAccount',
            'selectedServiceAccountContract',
            'selectedServiceAccountAdditionalInfo',
        ]),
        haveKollusAdminRight() {
            return !_.isEmpty(this.getLoginAccountRole) && this.getLoginAccountRole === 'kollus administrator';
        },
        haveOwnerRight() {
            return !_.isEmpty(this.getLoginAccountRole) && (this.getLoginAccountRole === 'kollus administrator' ||
                this.getLoginAccountRole === 'partner administrator' || this.getLoginAccountRole === 'owner');
        },
        haveManagerRight() {
            return this.haveOwnerRight || this.getLoginAccountRole === 'manager';
        },
        useFileToLive() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccountContract.live_use_file_to_live;
        },
        useWebRtc() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccountContract.live_use_webrtc;
        },
        chattingAvailable() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccountContract.live_use_chatting_service &&
                this.selectedServiceAccount.chatting_service &&
                (this.selectedServiceAccount.chatting_service.id > 0);
        },
        chattingType() {
            if (!_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                typeof this.selectedServiceAccount.chatting_service !== 'undefined' &&
                'kind' in this.selectedServiceAccount.chatting_service) {
                return this.selectedServiceAccount.chatting_service.kind.type;
            }
            return '';
        },
        isKollusKindChatting() {
            return this.chattingAvailable &&
                (this.chattingType === 'kollus' || this.chattingType === 'kollus_server_only');
        },
        concurrentlyViewerLimitAvailable() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccountContract.live_use_concurrently_viewer_limit;
        },
        useExclusivePlayerPolicy() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccountContract.live_use_exclusive_player;
        },
        useConcurrentlyViewerLimitPolicy() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccountContract.live_use_concurrently_viewer_limit;
        },
        useTimeShiftPolicy() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccountContract.live_use_time_shift;
        },
        useThirdPartyDrmPolicy() {
            if (!_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountAdditionalInfo)) {
                return this.selectedServiceAccountAdditionalInfo.use_third_party_drm;
            }
            return false;
        },
        useDuplicateBlockPolicy() {
            if (!_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract)) {
                const duplicateBlockPolicy = this.selectedServiceAccountContract.duplicate_block_policy;
                return (duplicateBlockPolicy.indexOf('not used') === -1);
            }
            return false;
        },
        useCaptureBlockPolicy() {
            if (!_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract)) {
                const captureBlockPolicy = this.selectedServiceAccountContract.capture_block_policy;
                return (captureBlockPolicy.indexOf('not used') === -1);
            }
            return false;
        },
        captureBlockPolicyInfo() {
            if (!_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract)) {
                const captureBlockPolicy = this.selectedServiceAccountContract.capture_block_policy;
                if (captureBlockPolicy.indexOf('use teruten') !== -1) {
                    return 'teruten';
                } else if (captureBlockPolicy.indexOf('not used') !== -1) {
                    return 'no';
                }
                return 'yes';
            }
            return 'no';
        },
        useLMSCallback() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccountContract.live_use_lms_callback;
        },
        usePlayCallback() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccountContract.live_use_play_callback;
        },
        snapshotAvailable() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccountContract.live_use_snapshot;
        },
        fileTransferAvailable() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccount.contract.live_use_recording_file;
        },
        syndicationAvailable() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccountContract.live_use_syndication;
        },
        /**
         * @desc
         *    - service account 정보를 다 로딩했을 때 체크
         *    - selectedServiceAccount, selectedServiceAccount.key 체크
         * @returns {boolean}
         */
        loadedServiceAccount() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccount.key);
        },
        loadedLoginAccount() {
            return !_.isEmpty(this.getLoginAccount) && !_.isEmpty(this.getLoginAccount.timezone);
        },
        useCmaf() {
            return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccountContract.live_use_cmaf;
        },
        useAES128() {
          return !_.isEmpty(this.selectedServiceAccount) && !_.isEmpty(this.selectedServiceAccountContract) &&
              this.selectedServiceAccountContract.live_use_aes128;
      },
    },
    watch: {
        selectedServiceAccount(newValue, oldValue) {
            if (typeof oldValue.key !== 'undefined' && newValue.key !== oldValue.key) {
                if (this.global_reload_path !== '') {
                    this.$router.push({ name: this.global_reload_path });
                } else {
                    location.reload();
                }
            }
        },
    },
};
